/// 数据看板客户组件
<template>
  <div class="index-box">
    <div style="margin-bottom: 0.5rem;">
      <p class="text-title">客户过程管理</p>
    </div>
    <CustomerKeyData :formState="props.formState"/>
<!--    <a-row :gutter="8">
      <a-col :span="8">
        &lt;!&ndash; 客户阶段状态 &ndash;&gt;
        <CustomerStageStatus appId="cos_fbu" :employeeNo="props.employeeNo"/>
      </a-col>
      <a-col :span="8">
        &lt;!&ndash; 成交客户分布情况 &ndash;&gt;
        <TransactCustomerDistribution appId="cos_fbu" :employeeNo="props.employeeNo"/>
      </a-col>
      <a-col :span="8">
        &lt;!&ndash; 跟进及时率 &ndash;&gt;
        <FollowInTimeRate appId="cos_fbu" :employeeNo="props.employeeNo"/>
      </a-col>
    </a-row>-->
<!--    <a-col :span="24">-->
<!--      &lt;!&ndash; 客户汇总 &ndash;&gt;-->
<!--      <CustomerGathering appId="cos_fbu" :employeeNo="props.employeeNo"/>-->
<!--    </a-col>-->
<!--    <a-row :gutter="8">-->
<!--      <a-col :span="10">-->
<!--        &lt;!&ndash; 异动反馈情况 &ndash;&gt;-->
<!--        <AlarmFeedback appId="cos_fbu" :employeeNo="props.employeeNo"/>-->
<!--      </a-col>-->
<!--      <a-col :span="7">-->
<!--        &lt;!&ndash; 异动类型分布 &ndash;&gt;-->
<!--        <AlarmDistribution appId="cos_fbu" distributionType="1" :employeeNo="props.employeeNo"/>-->
<!--      </a-col>-->
<!--      <a-col :span="7">-->
<!--        &lt;!&ndash; 异动等级分布 &ndash;&gt;-->
<!--        <AlarmDistribution appId="cos_fbu" distributionType="2" title="异动等级分布"-->
<!--                           :employeeNo="props.employeeNo"/>-->
<!--      </a-col>-->
<!--    </a-row>-->
    <a-row :gutter="8">
        <a-col :span="8">
          <!-- 客户阶段状态 -->
          <CustomerStageStatus height="300px" appId="cos_fbu" :formState="props.formState"/>
        </a-col>
        <a-col :span="8">
          <!-- 跟进及时率 -->
          <FollowInTimeRate height="300px" appId="cos_fbu" :employeeNo="props.formState.employeeNo"/>
        </a-col>
        <a-col :span="8">
          <!-- 异动整合 -->
          <AlarmPieCombine height="300px" appId="cos_fbu" :formState="props.formState"/>
        </a-col>
    </a-row>
    <a-row :gutter="8">
      <a-col :span="8">
        <!-- 成交客户分布情况 -->
        <TransactCustomerDistribution height="300px" appId="cos_fbu" :formState="props.formState"/>
      </a-col>
      <a-col :span="8">
        <!-- 客户拜访完成情况 -->
        <CustomerVisitCompletionStatus height="300px" appId="cos_fbu" :formState="props.formState"/>
      </a-col>
      <a-col :span="8">
        <!-- 异动趋势 -->
        <CustomerAlarmTrend height="300px" appId="cos_fbu" :employeeNo="props.formState.employeeNo"/>
      </a-col>
    </a-row>
<!--    <a-col :span="24">-->
<!--      &lt;!&ndash; 异动趋势 &ndash;&gt;-->
<!--      <CustomerAlarmTrend appId="cos_fbu" :employeeNo="props.employeeNo"/>-->
<!--    </a-col>-->
  </div>
</template>
<script lang="ts" setup>
import CustomerStageStatus from '@/views/gucangSales/dataBoard/componects/CustomerStageStatus.vue'
import FollowInTimeRate from '@/views/gucangSales/dataBoard/componects/FollowInTimeRate.vue'
import CustomerKeyData from '@/views/gucangSales/dataBoard/componects/CustomerKeyData.vue'
import TransactCustomerDistribution from '@/views/gucangSales/dataBoard/componects/TransactCustomerDistribution.vue'
import { PropType } from 'vue'
import CustomerAlarmTrend from '@/views/gucangSales/dataBoard/componects/CustomerAlarmTrend.vue'
import AlarmPieCombine from '@/views/gucangSales/dataBoard/componects/AlarmPieCombine.vue'
import CustomerVisitCompletionStatus from '@/views/gucangSales/dataBoard/componects/CustomerVisitCompletionStatus.vue'

const props = defineProps({
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_lbu'>,
    default: 'cos_fbu'
  },
  formState: {
    type: Object as PropType<Object>
  }
})
</script>
<script lang="ts">
export default { name: 'CustomerDataBoardComponent' }
</script>
<style scoped lang="scss">
.index-box {
  background: rgb(249, 249, 255);
  padding: 10px;
}
.text-title {
  font-size: 20px;
  font-weight: 500;
  color: #000;
}
</style>
